<div class="top-master-key-container">
  <p>top-master-key works!</p>

  <p>Select number of pins:</p>

  <div>
    <input type="radio" id="six" name="pins" value="six" [(ngModel)]="pins"
           checked>
    <label for="six">Six</label>
  </div>

  <div>
    <input type="radio" id="five" name="pins" value="five" [(ngModel)]="pins">
    <label for="five">Five</label>
  </div>

  <div>
    <label for="parity">Parity</label>
    <input id="parity" type="text" [(ngModel)]="parity">
  </div>

  <input type="button" value="Generate" (click)="onGenerate()">

  <div *ngFor="let keyResult of this.keysObservable$ | async">
    <p>Key cuts:</p>
    <p>Combinate rule: name: {{keyResult.combinatingRuleKeyCut.name}}, highest
      Cut: {{keyResult.combinatingRuleKeyCut.highestCut}}, lowest Cut: {{keyResult.combinatingRuleKeyCut.lowestCut}},
      max Adjacent Cut: {{keyResult.combinatingRuleKeyCut.maxAdjacentCut}}, Progression Steps: {{keyResult.combinatingRuleKeyCut.totalProgressionSteps}} </p>
    <p>SOP: {{keyResult.sequenceOfProgression}} </p>
    <div class="key-container">
      <div *ngFor="let keyOrder of keyResult.keyOrderDtos">
        <p>{{keyOrder.key}}, {{keyOrder.order}}</p>
        <ul>
          <li *ngFor="let kba of keyOrder.keyBitArray">{{kba}}</li>
        </ul>
      </div>
    </div>
  </div>
</div>

